export default __webpack_public_path__ + "images/arrow-white-icon.svg?8eafbf281899eb4a9410e2dc2e8bd3ed";